import React from "react";
import FolieLayout from "./FolieLayout.jsx";
import LkwSchaubild from "./LkwSchaubild.jsx";

function einstellungWert(einstellungen, schluessel) {
    const eintrag = (einstellungen || []).find((e) => e.schluessel === schluessel);
    return eintrag ? Number(eintrag.wert) : null;
}

export default function Folie7Lkw({einstellungen}) {
    const lkwKapazitaetStueck = einstellungWert(einstellungen, "lkw_kapazitaet_stueck");
    const paletteStueck = einstellungWert(einstellungen, "palette_stueck");

    return (
        <FolieLayout
            nummer={8}
            titel="Vom Vorschlag zum LKW"
            hilfe="Cosmos liefert nur volle LKW – die Bestellvorschläge einer Lieferwoche werden danach sortiert, wie dringend, wie gängig und wie wichtig ein Farbton ist."
            text={
                <p className="mb-0">
                    Cosmos liefert nur volle Lastwagen. Die Bestellvorschläge einer Lieferwoche werden deshalb
                    zusammengefasst und nach Dringlichkeit sortiert, dann nach von Hand markierten Top-Farbtönen und
                    zuletzt nach dem Verkaufsrang – so wird ein nicht ganz voller LKW mit den Farbtönen aufgefüllt, die
                    am ehesten gebraucht werden. Der Vorschlag bestellt dabei nichts von selbst: Jede Zeile wird geprüft
                    und erst dann übernommen oder verworfen.
                </p>
            }
            leseHinweis="Jedes grüne Feld in der Ladefläche steht für eine Palette. Die Zahl darunter zeigt, wie viele Paletten in einen LKW passen – live aus der gepflegten Einstellung, nicht fest im Programm hinterlegt."
        >
            <LkwSchaubild lkwKapazitaetStueck={lkwKapazitaetStueck} paletteStueck={paletteStueck} />
        </FolieLayout>
    );
}
